import {computed, inject, Injectable, signal} from '@angular/core';
import {UserService} from "../../../services/user.service";
import {MalfunctionStatus, Report} from "../../../shared/interfaces/report";
import {ReportService} from "../../error-report/data-access/report.service";
import {ApiService} from "../../../services/api.service";
import {forkJoin} from "rxjs";
import {Userrole} from "../../../shared/interfaces/user";
import {CookieService} from "ngx-cookie-service";

interface DashboardData {
  reports: Report[];
  escalations: Report[];
}

@Injectable({
  providedIn: 'root'
})
export class DashboardDataService {
  readonly userService = inject(UserService);
  readonly reportService = inject(ReportService);
  readonly apiService = inject(ApiService);
  readonly cookieService = inject(CookieService);

  // state
  private dashboardDataState = signal<DashboardData>({
    reports: [],
    escalations: []
  })

  // selectors
  escalatedReports = computed(() => {
    return [...(this.dashboardDataState().escalations ?? [])]
      .sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
  })
  solvedReports = computed(() => this.dashboardDataState().reports
    .filter(report => report.status === MalfunctionStatus.SOLVED)
    .sort((a, b) => new Date(b.solved_on!).getTime() - new Date(a.solved_on!).getTime())
  );
  activeReports = computed(() => {
    const escalationIds = new Set(this.escalatedReports().map(e => e.id));
    return this.dashboardDataState().reports.filter(report => report.status === MalfunctionStatus.ESCALATED && !escalationIds.has(report.id));
  });

  loadDashboardData(): void {

    forkJoin({
      filteredReports: this.apiService.getFilteredReports({
        statusFilter: [MalfunctionStatus.ESCALATED, MalfunctionStatus.SOLVED],
        statusLimits: {[MalfunctionStatus.SOLVED]: '5'},
        productionLineFilter: this.getProductionLineFilter() ? Array(this.getProductionLineFilter()!) : undefined
      }),
      activeEscalation: this.apiService.getActiveEscalations(this.userService.user()!)
    }).subscribe(({filteredReports, activeEscalation}) => {
      console.log('result', {filteredReports, activeEscalation});
      this.dashboardDataState.update((dashboardData) => ({
        ...dashboardData,
        reports: filteredReports.reportData,
        escalations: activeEscalation
      }));
    })
  }

  getProductionLineFilter() {
    let productionLineFilter: string | undefined = undefined;
    switch (this.userService.userrole()) {
      case Userrole.Mitarbeiter:
        productionLineFilter = this.cookieService.get("productionLine")?.split("%")[0];
        break;
      case Userrole.Teamleiter:
      case Userrole.Schichtleiter:
        productionLineFilter = this.userService.user()?.app_metadata['productionLine'].split('%')[0];
        break;
      default:
        return;
    }
    return productionLineFilter;
  }
}
